import { Switch } from '@/components/ui'

interface ConfirmationStepProps {
  sendConfirmation: boolean
  onChange: (value: boolean) => void
}

export default function ConfirmationStep({ sendConfirmation, onChange }: ConfirmationStepProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
      <div>
        <h3 style={{ fontSize: '16px', fontWeight: 500, color: '#111827', marginBottom: '8px' }}>
          Send confirmation emails
        </h3>
        <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '16px' }}>
          Choose whether to send registration confirmation emails to newly imported attendees.
        </p>
      </div>

      <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <span style={{ fontWeight: 500 }}>Send confirmation letter to newly imported attendees</span>
            <p style={{ fontSize: '14px', color: '#6b7280' }}>
              Only new attendees will receive the email. Updated attendees will not receive a new confirmation.
            </p>
          </div>
          <Switch
            checked={sendConfirmation}
            onChange={onChange}
          />
        </div>
      </div>

      {sendConfirmation && (
        <div style={{ backgroundColor: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '8px', padding: '16px' }}>
          <p style={{ fontSize: '14px', color: '#1e40af' }}>
            <strong>Note:</strong> Confirmation emails will be sent using your event's registration confirmation email template.
            Make sure the template is configured and enabled in your event settings.
          </p>
        </div>
      )}
    </div>
  )
}
